import React from 'react';
import PropTypes from 'prop-types';
import Select from '../Select';
import { TEST_PURPOSES } from '../../../constants/test';


const TestPurposeDropdown = ({ value, onChange }) => (
  <Select
    value={value}
    onChange={onChange}
    options={TEST_PURPOSES}
  />
);

TestPurposeDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default TestPurposeDropdown;


// WEBPACK FOOTER //
// src/components/shared/TestPurposeDropdown/index.jsx